const doc = [({"da":({"js":({"admin":({"photo_sessions":({"upload_csv_modal":({"index":({"choose_csv_type":"Vælg csvtype", "upload_csv_file":"Upload csvfil"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;